import React from 'react'
import ReactDOM from 'react-dom/client'
import { ThemeProvider, CssBaseline } from '@mui/material'
import { theme } from './styles/theme'
import { TierProvider } from './hooks/useTier'
import App from './App'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <TierProvider>
        <App />
      </TierProvider>
    </ThemeProvider>
  </React.StrictMode>
)
